import React, { useEffect } from 'react';
import { Link } from "react-router-dom";
import LayoutWrapper from "../layout/layoutWrapper/LayoutWrapper";
import { Helmet } from "react-helmet";
import "./NotFound.css"; // Button and layout styles
import logo from "../assets/images/404img.png";

const NotFound = () => {

    // Load Zoho SalesIQ Script
    useEffect(() => {
      const script = document.createElement("script");
      script.src = "https://salesiq.zoho.com/widget"; // Replace with your SalesIQ Widget script link
      script.async = true;
      document.body.appendChild(script);
    }, []);
  
    // Function to Show Chat Window
    const openChat = () => {
      if (window.$zoho && window.$zoho.salesiq) {
        window.$zoho.salesiq.floatwindow.visible("show");
      } else {
        console.error("Zoho SalesIQ not loaded");
      }
    };
  return (
    <>
      <Helmet>
        <title>Page Not Found - INKOX</title>
        <meta name="description" content="The page you are looking for does not exist." />
      </Helmet>

      <LayoutWrapper>
        <div className="mainerrorpage">
          <div className="error-flex-container">
            {/* Left Column - Image */}
            <div className="error-image-section">
              <img src={logo} alt="Page Not Found" className="error-image" />
            </div>

            {/* Right Column - Text */}
            <div className="error-text-section">
              <p className="error-message">
                Sorry, the page you are looking for doesn’t exist or has been moved.
                But don't worry — we've got plenty of great options for you.
              </p>

              <Link to="/" className="inkox-primary-button">Go Back Home</Link>

              <h3 className="error-subheading">Explore Our Popular Categories</h3>
              <div className="error-links-grid">
                <Link to="/products/t-shirts/8" className="inkox-secondary-link">Custom T-Shirts</Link>
                <Link to="/products/hoodies-&-sweatshirts/9" className="inkox-secondary-link">Printed Hoodies</Link>
                <Link to="/products/headwears/10" className="inkox-secondary-link">Embroidered Hats</Link>
                <Link to="/products/jackets-&-vests/11" className="inkox-secondary-link">Company Jackets</Link>
                <Link to="/products/sports-&-athletics/17" className="inkox-secondary-link">Team Sportswear</Link>
              </div>

              <p className="error-contact">
                Still can’t find what you're looking for? <Link><span  onClick={openChat} >Contact our support team</span></Link>  for help.
              </p>
            </div>
          </div>
        </div>
      </LayoutWrapper>
    </>
  );
};

export default NotFound;
